import { exists } from '@engine/lib/utility/exists'; // LEGACY CODE

export function toggleRatios() {
  var panelClass = '.toggable';
  var panelBodyClass = '.panel-body';
  var loadClass = '.panel-load';
  var hideClass = '.panel-hide';
  var showClass = '.panel-show';
  var hiddenClass = 'hidden';

  if (!exists($(panelClass))) {
    return 0;
  }

  $(loadClass).on('click', function (e) {
    var trigger = $(e.target);
    var panel = trigger.closest(panelClass);
    trigger.remove();
    panel.find(panelBodyClass).removeClass(hiddenClass).html('<div class="loading visible"></div>');
    panel.find(hideClass).removeClass(hiddenClass);
  });
  $(hideClass).on('click', function (e) {
    var trigger = $(e.target);
    var panel = trigger.closest(panelClass);
    trigger.addClass(hiddenClass);
    panel.find(panelBodyClass).addClass(hiddenClass);
    panel.find(showClass).removeClass(hiddenClass);
  });
  $(showClass).on('click', function (e) {
    var trigger = $(e.target);
    var panel = trigger.closest(panelClass);
    trigger.addClass(hiddenClass);
    panel.find(panelBodyClass).removeClass(hiddenClass);
    panel.find(hideClass).removeClass(hiddenClass);
  });
}